import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import { ModalContext } from 'App';
import googleImage from 'assets/img/google-authenticator.svg';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../../../actions';

function AuthenticatorSetup({
  generate2fa,
  goBack,
  enable2fa,
  history,
  profile,
  token,
  selectedMfa,
  updateMfaType
}) {

  const [formData, setFormData] = useState({})
  const setModal = useContext(ModalContext);

  const handleOnGenerateMicrosoft = e => {
    e.preventDefault();

    generate2fa({
      email: profile.email,
      token,
    }, (data) => {
      setFormData(data.data);
    });
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    goBack(0);
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnVerify = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      email: profile.email,
      token,
    };
    enable2fa(args, () => {
      if (selectedMfa === 1) {
        const mfaPayload = {
          token,
          preferred_mfa: 'google_authenticator',
          email: profile.email
        }
        updateMfaType(mfaPayload, () => {
        });
      }
      setModal({ isOpen: false });
      history.push('/');
    });
  };

  useEffect(() => {
    generate2fa({
      email: profile.email,
      token,
    }, (data) => {
      setFormData(data.data);
    });
  }, []);

  return (
    <div className="mfa-modal">
      <div className='col-12 title'>
        Please follow the steps below to enable MFA via Authenticator App:
      </div>
      <div className='col-12 numeric ml-1 mt-3'>
        1. Download an authenticator app
      </div>
      <div className='col-12 ml-3 title'>
        Install an authenticator app to your phone. You&apos;ll use this app to
        generate verification codes when logging in. Here are some options
        to install on your IOS/Android device:
      </div>
      <div className="col-6 ml-4 mt-2 p-1 border rounded-sm" style={{ width: 'fit-content'}}>
        <button
          type="button"
          onClick={handleOnGenerateMicrosoft}
          className='mfa-button'
        >
          <img
            src={googleImage}
            style={{ height: '20px', width: '20px' }}
            alt="Microsoft Authenticator"
          />
          <span className='title mt-2 ml-3'>
            Google Authenticator
          </span>
        </button>
      </div>
      <div className='col-12 numeric ml-1 mt-3'>
        2. Scan QR Code with authenticator app
      </div>
      <div className='col-12 ml-3 title-setupkey'>
        Open your downloaded authenticator app on your phone and scan the QR code. This will link the app to your GoManila account.
      </div>
      <div className='mt-3 d-flex ml-2 pl-3'>
        {_.get(formData, 'data.qr_code_url') ? (
          <>
            <div className='col-5 border ml-2'>
              <img
                alt=""
                src={_.get(formData, 'data.qr_code_url')}
                style={{ height: '100px', width: '100px', marginTop: '8px', marginBottom: '8px', marginLeft: '30px' }}
                className="text-center"
              />
            </div>
            <div className='col-6 border ml-2'>
              <div>
                <p className="text-center mt-3 pt-1 mb-2 title-setupkey">
                    You can also enter this setup key:
                </p>
              </div>
              <div>
                <p className="text-center mt-0 cms-text-primary">{`${_.get(formData, "data.google2fa_secret")}`}</p>
              </div>
            </div>
          </>
        ) : (
          <div className="border text-center p-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
              style={{ height: '150px', width: '150px', top: '-5px' }}
            />
          </div>
        )}
      </div>
      <div className='col-12 numeric ml-1 mt-3'>
        3. Enter verification code
      </div>
      <div className='col-12 ml-3 title'>
        After scanning the QR code or entering the setup key above, your authenticator app
        will generate a verification code. Enter this code below to verify your setup.
      </div>
      <div className="input-group mb-3 col-10 mt-2 ml-3">
        <InputMask
          placeholder='Enter verification code'
          className='form-control'
          maskChar=' '
          mask='999999'
          autoComplete='none'
          id='secret'
          name='secret'
          onChange={handleOnChange}
          value={_.get(formData, "secret") || ""}
        />
        <div className="input-group-append">
          <button
            type="button"
            disabled={_.isEmpty(_.get(formData, "secret"))}
            className="btn btn-submit"
            onClick={handleOnVerify}
          >
            Submit
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={handleGoBack}
          className="mt-3 btn btn-change cms-text-primary"
        >
          <span className="font-weight-bold">
            Change Authentication Method
          </span>
        </button>
      </div>
    </div>
  );
};

AuthenticatorSetup.defaultProps = {
  selectedMfa: 0
};


AuthenticatorSetup.propTypes = {
  generate2fa: PropTypes.instanceOf(Function).isRequired,
  goBack: PropTypes.instanceOf(Function).isRequired,
  enable2fa: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  token: PropTypes.string.isRequired,
  selectedMfa: PropTypes.number,
  updateMfaType: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
  token: sessionStorage.getItem('temporaryToken') || '',
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(AuthenticatorSetup);